import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  Botao,
  Breadcrumb,
  Cabecalho,
  ContainerAcoes,
  Filtro,
  IconeEditar,
  TabelaDados,
  TabelaRef,
  TabelaResposta,
  Tooltip
} from 'src/componentes'
import {
  Container,
  Form,
  ContainerDados75,
  Dados
} from 'src/componentes/styles/filtro'
import { InputUnform, SelectUnform } from 'src/componentes/unform'
import { RotasParceiroCertificacao, RotasTurmaCertificacao } from 'src/rotas'
import { Api } from 'src/servicos'
import { TipoOrdenacao, UsuarioPerfil, UsuarioSituacao } from 'src/tipos'

import { ContainerCertificacao } from '../styles'
import { TabelaComEstilos } from './styles'

interface DadosPesquisa {
  nome: string
  email: string
  situacao: keyof typeof UsuarioSituacao
  cnpj: string
  docIdentidade: string
  perfis: Array<keyof typeof UsuarioPerfil>
}

export const PaginaParceirosCertificacao: React.FC = () => {
  const history = useHistory()
  const [dadosPesquisa, definirDadosPesquisa] = useState<DadosPesquisa>(null)
  const tabelaRef = useRef<TabelaRef>()
  const [paginas, definirPaginas] = useState(null)

  const obterDados = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (paginas !== null) {
      numeroPaginas = paginas
    }

    const dados = await Api.RequisitarListaParceiros(
      dadosPesquisa?.nome,
      dadosPesquisa?.email,
      dadosPesquisa?.situacao,
      dadosPesquisa?.cnpj,
      dadosPesquisa?.docIdentidade,
      dadosPesquisa?.perfis,
      numeroPaginas,
      quantidadePorPagina,
      chaveOrdenacao,
      ordem
    )

    if (!dados) return null
    definirPaginas(null)

    return {
      Dados: dados.registros,
      Paginacao: {
        Pagina: dados.opcoesPaginacao.pagina,
        TotalRegistros: dados.opcoesPaginacao.totalRegistros
      }
    } as TabelaResposta
  }

  useEffect(() => {
    if (dadosPesquisa === null) return
    tabelaRef.current.IrParaPagina()
    tabelaRef.current.CarregarDados()
  }, [dadosPesquisa])

  const acaoPesquisa = (dados: DadosPesquisa) => {
    if (dados !== null && paginas !== 1) {
      definirPaginas(1)
    }
    definirDadosPesquisa(dados)
  }

  return (
    <ContainerCertificacao>
      <Cabecalho>
        <Breadcrumb
          titulo="Pesquisa de Parceiros certificação"
          atalhos={[
            {
              texto: 'Acadêmico'
            },
            {
              texto: 'Parceiros'
            }
          ]}
        />
      </Cabecalho>
      <Filtro>
        <Form
          dadosIniciais={{
            situacao: UsuarioSituacao[UsuarioSituacao.Todas],
            modalidade: 'Todas'
          }}
          acaoSucesso={acaoPesquisa}
        >
          <Container>
            <ContainerDados75>
              <InputUnform type="text" name="cnpj" label="CNPJ" />
            </ContainerDados75>
            <ContainerDados75>
              <InputUnform type="text" name="nome" label="Nome" />
            </ContainerDados75>
          </Container>
          <Container>
            <ContainerDados75>
              <InputUnform type="text" name="email" label="Email" />
            </ContainerDados75>
            <ContainerDados75>
              <SelectUnform
                id="slct_situacao"
                name="situacao"
                label="Situação"
                iconeFechar={false}
                opcoes={[
                  {
                    id: UsuarioSituacao[UsuarioSituacao.Todas],
                    texto: 'Todas'
                  },
                  {
                    id: UsuarioSituacao[UsuarioSituacao.Ativo],
                    texto: 'Ativo'
                  },
                  {
                    id: UsuarioSituacao[UsuarioSituacao.Inativo],
                    texto: 'Inativo'
                  }
                ]}
              />
            </ContainerDados75>
          </Container>
          <Botao
            type="submit"
            id="btn-aplicar-filtro"
            texto="Aplicar filtro"
            tema="Link"
          />
        </Form>
      </Filtro>
      <Dados>
        <TabelaComEstilos
          ref={tabelaRef}
          Colunas={[
            {
              Chave: 'cnpj',
              Texto: 'CNPJ',
              Renderizar: (linha: any) =>
                linha?.cnpj === '' ? '-' : linha.cnpj,
              ComOrdenacao: true
            },
            {
              Chave: 'nome',
              Texto: 'Nome',
              ComOrdenacao: true
            },
            {
              Chave: 'email',
              Texto: 'Email',
              ComOrdenacao: true
            },
            {
              Chave: 'acoes',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <ContainerAcoes>
                  <button
                    type="button"
                    data-tip="Editar"
                    data-for={`${linha.id}-tooltip-editar`}
                    onClick={() =>
                      history.push(
                        `${RotasParceiroCertificacao.MeuCadastro}/${linha.id}`,
                        {
                          modalidade: linha.modalidade
                        }
                      )
                    }
                    onContextMenu={() => {
                      const rota = window.open(
                        `${RotasTurmaCertificacao.Edicao}/${linha.id}/${linha.modalidade}`
                      )
                      rota.focus()
                    }}
                  >
                    {IconeEditar}
                  </button>
                  <Tooltip
                    id={`${linha.id}-tooltip-editar`}
                    place="bottom"
                    offset={{ top: 10 }}
                  />
                </ContainerAcoes>
              )
            }
          ]}
          ObterDados={obterDados}
          ComPaginacao
        />
      </Dados>
    </ContainerCertificacao>
  )
}
